/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getMeResponseDataSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().optional(),
  image: z.string().optional(),
  role: z.string().optional(),
});

export type IGetMeResponseData = z.infer<typeof getMeResponseDataSchema>;

export const getMeResponseSchema = createApiResponseSchema(getMeResponseDataSchema) as z.ZodSchema<
  IAPI<IGetMeResponseData>
>;

export type IGetMeResponse = IAPI<IGetMeResponseData>;
